import SidebarIntents from 'components/ReusableComponents/Messaging/Sidebar/SidebarIntents'
import {
  categoryNames,
  getChatRouteFromMessagingType,
  getStoreNameFromMessagingType,
  isUnidentifiedOtpThread,
  sortThreads
} from 'features/Messaging/messaging-helpers'
import SearchAndMessageGuest from 'features/Messaging/SearchAndMessageGuest'
import { useInternalAdmin } from 'hooks'
import useLocalStorage from 'hooks/useLocalStorageState'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import RowGroup from '../ConverastionRowGroup/index'
import Row from '../ConversationRow/index'
import SidebarControls from '../SidebarControls/index'
import styles from './Sidebar.module.scss'

function filterThreads(thread, filterQuery) {
  let threadString = ''

  if (!thread) return false

  if (thread.subscriber) {
    threadString += thread.subscriber
  }

  if (thread.roomNumber) {
    threadString += thread.roomNumber
  }

  if (thread.lastMessage) {
    threadString += thread.lastMessage
  }

  if (threadString.match(new RegExp(filterQuery, 'i'))) {
    return true
  }

  return false
}

const Sidebar = ({ messagingType, currentThread }) => {
  const [filterQuery, setFilterQuery] = useState('')
  const [sortParam, setSortParam] = useState('time')
  const [intentToFilter, setIntentToFilter] = useState(null)

  const baseUrl = getChatRouteFromMessagingType(messagingType)

  const store = getStoreNameFromMessagingType(messagingType)

  const threads = useSelector(s => s[store].threads)

  const isInternalAdmin = useInternalAdmin()

  let combinedThreads = threads

  if (currentThread?.chatId) {
    combinedThreads = { ...threads, [currentThread?.chatId]: currentThread }
  }

  const [filterTimeTresholdInDays, setFilterTimeTresholdInDays] = useLocalStorage(
    'messagingFilterTimeTresholdInDays',
    150
  )

  const { chatId: currentchatId } = useParams()

  function getThreads(threads, filterQuery, intentToFilter) {
    return threads.map(t => getThreadsWithCat(t, filterQuery, intentToFilter))
  }

  function getCheckoutAndResolvedThreads() {
    const filteredThreads = Object.keys(combinedThreads)
      .filter(
        k => combinedThreads[k].status === 'Closed' && combinedThreads[k].isCheckedOut
      )
      .filter(k => filterThreads(combinedThreads[k], filterQuery))
    if (filteredThreads.length) {
      if (filteredThreads.length) {
        return (
          <RowGroup
            collapsedByDefault={true}
            title={`Checked out and resolved (${filteredThreads.length})`}
            bottomGroup={true}
            count={filteredThreads.length}
          >
            {filteredThreads
              .map(k => combinedThreads[k])
              .sort(sortThreads(sortParam))
              .map(t => (
                <Row
                  baseUrl={baseUrl}
                  key={t.chatId}
                  active={String(t.chatId) === currentchatId}
                  {...t}
                />
              ))}
          </RowGroup>
        )
      }
    }
  }

  function getThreadsWithCat(
    status,
    filterQuery = '',
    intentToFilter,
    showGDSBookings = false
  ) {
    const filteredThreads = Object.keys(combinedThreads)
      .filter(k => combinedThreads[k].status === status)
      .filter(k => combinedThreads[k].isGdsBooking === showGDSBookings)
      .filter(
        k => !(combinedThreads[k].status === 'Closed' && combinedThreads[k].isCheckedOut)
      )
      .filter(k => filterThreads(combinedThreads[k], filterQuery))
      .filter(k =>
        intentToFilter ? combinedThreads[k].lastMessageBotIntent === intentToFilter : true
      )
      .filter(
        k =>
          moment().diff(moment(combinedThreads[k].lastMessageOn), 'days') <=
          filterTimeTresholdInDays
      )
      .filter(k => {
        // Before stay hotel staff must see every waiting thread, including unidentified OTP.
        if (isInternalAdmin || messagingType === 'sales') {
          return true
        }
        return !isUnidentifiedOtpThread(combinedThreads[k])
      })
    if (filteredThreads.length) {
      return (
        <RowGroup
          chatCat={showGDSBookings ? 'GdsBooking' : status}
          key={status}
          title={showGDSBookings ? 'GDS bookings' : categoryNames[status]}
          shouldShowCount={status === 'ClientWaiting'}
          isGdsBooking={showGDSBookings}
          count={filteredThreads.length}
        >
          {filteredThreads
            .map(k => combinedThreads[k])
            .sort(sortThreads(sortParam))
            .map(t => (
              <Row
                baseUrl={baseUrl}
                chatCat={showGDSBookings ? 'GdsBooking' : status}
                key={t.chatId}
                active={String(t.chatId) === currentchatId}
                {...t}
              />
            ))}
        </RowGroup>
      )
    }
    return null
  }

  return (
    <div className={styles.sidebar}>
      <SidebarControls
        handleSearchChange={setFilterQuery}
        handleSortChange={setSortParam}
        sortParam={sortParam}
        filterTimeTresholdInDays={filterTimeTresholdInDays}
        setFilterTimeTresholdInDays={setFilterTimeTresholdInDays}
      />

      {messagingType === 'direct' && <SearchAndMessageGuest />}
      <SidebarIntents threads={threads} onChangeActiveIntent={setIntentToFilter} />
      <div className={styles.container}>
        {messagingType === 'sales' &&
          isInternalAdmin &&
          getThreadsWithCat('ClientWaiting', filterQuery, intentToFilter, true)}
        {messagingType === 'sales' &&
          isInternalAdmin &&
          getThreadsWithCat('AgentResponded', filterQuery, intentToFilter, true)}
        {getThreads(
          [
            'StartedManually',
            'Started',
            'ClientWaiting',
            'Rated',
            'AgentResponded',
            'Closed'
          ],
          filterQuery,
          intentToFilter
        )}
        {getCheckoutAndResolvedThreads()}
      </div>
    </div>
  )
}

export default Sidebar
